import { connect } from "react-redux";
import { fetchGameInfoAction } from "../myResultsActions";
import RankingsPage from "../../Ranking/RankingPage.jsx";
import { compose, lifecycle, mapProps } from "recompose";

const RankingsPageContainer = compose(
  mapProps(({ match: { params: { game } } }) => ({ gameId: game })),
  connect(
    (state, { gameId }) => {
      let game = state.games.current;
      let loading = state.games.loading;

      if (loading) {
        return { loading };
      }

      let needsReload = !game || String(game.id) !== gameId;
      if (needsReload) {
        return { needsReload, loading: true, gameId };
      }

      return {
        current: state.games.current,
        links: state.games.links,
        redirectUrl: state.ranking.redirectUrl,
        gameId: gameId,
      };
    },
    (dispatch) => ({
      onLoad: (id) => dispatch(fetchGameInfoAction({ id })),
    })
  ),
  lifecycle({
    componentDidUpdate() {
      this.handleLoad();
    },

    componentDidMount() {
      this.handleLoad();
    },

    handleLoad() {
      if (this.props.needsReload) {
        this.props.onLoad(this.props.gameId);
      }
    },
  })
)(RankingsPage);

export default RankingsPageContainer;
